import React from "react";
import { Card } from "antd";
import { displayIcon } from "variables/icons";

const AbsenceSummaryCard = ({
  currentlyOut = 0,
  upcomingThisWeek = 0,
  upcomingThisMonth = 0,
  totalDays = 0,
}) => {
  const absenceData = [
    {
      label: "Currently Out",
      count: currentlyOut,
      category: "currently-out",
      icon: "UserX",
    },
    {
      label: "Upcoming (This Week)",
      count: upcomingThisWeek,
      category: "this-week",
      icon: "Clock",
    },
    {
      label: "Upcoming (This Month)",
      count: upcomingThisMonth,
      category: "this-month",
      icon: "Calendar",
    },
    {
      label: "Total Days (Month)",
      count: totalDays,
      category: "total",
      icon: "TrendingUp",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {absenceData.map((item) => (
        <Card
          key={item.id}
          className={`card-border-s ${item.category} rounded-2xl`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-[12px] dark:text-white mb-1">{item.label}</p>
              <p className="text-[24px] font-semibold card-text">{item.count}</p>
            </div>
            <div className="avatar rounded-lg">
              {displayIcon(item.icon, "")}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default AbsenceSummaryCard;
